import classNames from 'classnames';
import React, { useState } from 'react';
import EfDialogYoutube from '../ef-dialog-youtube';
import EfImgVideo from '../ef-img-video';
import IconWatch from './IconWatch';
import gtm from '@/utils/gtm';
import './index.scss';

interface EfBannerProps {
    /**
     * 主题色
     */
    theme?: 'white' | 'black';
    /**
     * 资源链接是否是视频
     */
    isVideo?: boolean;
    /**
     * 所有分辨率展示的资源链接
     */
    pc: string;
    /**
     * 分辨率小于等于1024px展示的资源链接
     */
    pad?: string;
    /**
     * 分辨率小于等于1024px展示的资源链接
     */
    h5?: string;
    /**
     * 视频贴图-所有分辨率
     */
    poster?: string;
    /**
     * 视频贴图-分辨率小于等于1024px
     */
    posterH5?: string;
    /**
     * label(处于标题之上的叫label)
     */
    label?: React.ReactNode;
    /**
     * 主标题
     */
    title?: string;
    /**
     * 副标题
     */
    subTitle?: string;
    /**
     * 描述
     */
    desc?: string;
    /**
     * 文案摆放位置
     */
    position?: 'default' | 'hoverL';
    /**
     * 播放按钮-文案
     */
    btn_text?: string;
    /**
     * 播放按钮-链接
     */
    btn_link?: string;

    /**
     * 播放按钮2-文案
     */
    btn_text2?: string;
    /**
     * 播放按钮2-链接
     */
    btn_link2?: string;
    /**
     * 是否直接打开链接
     */
    isOpenLink?: boolean;
    /**
     * 埋点-触发位置(需要同时传 gtm_position 和 gtm_title_name 才会触发埋点)
     */
    gtm_position?: string;
    /**
     * 埋点-播放视频的名称(需要同时传 gtm_position 和 gtm_title_name 才会触发埋点)
     */
    gtm_title_name?: string;
    /**
     * 样式名
     */
    className?: string;
    /**
     * 是否有邮件订阅
     */
    hasEmail?: boolean;
    /**
     * 邮件订阅
     */
    emailChildren?: React.ReactNode;
    /**
     * 底部插槽
     */
    bottomChildren?: React.ReactNode;
}

/**
 * 维护:谢保林
 *
 * 首屏banner
 *
 * 支持2个播放youtube视频按钮
 */
const EfBanner: React.FC<EfBannerProps> = ({
    theme,
    isVideo,
    pc,
    pad,
    h5,
    poster,
    posterH5,
    label,
    title,
    subTitle,
    desc,
    position,
    btn_text,
    btn_link,
    btn_text2,
    btn_link2,
    isOpenLink = false,
    gtm_position,
    gtm_title_name,
    className,
    hasEmail,
    emailChildren,
    bottomChildren,
}) => {
    const prefixCls = `ef-banner`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-${position}`]: position,
        [`${prefixCls}-theme-${theme}`]: theme,
    });
    const [isOpen, setIsOpen] = useState(false);
    const [openHref, setOpenHref] = useState(btn_link);
    const hasBtn = (btn_text && btn_link) || (btn_text2 && btn_link2);
    // 打开弹窗
    const openHandle = (href?: string) => {
        if (isOpenLink) {
            window.open(href);
            return;
        }
        setIsOpen(true);
        setOpenHref(href);
    };
    // 关闭弹窗
    const hideHandle = () => {
        setIsOpen(false);
        setOpenHref('');
    };

    // 埋点-第1|2个按钮
    let btn_gtm = null;
    //if (gtm_title_name && gtm_position) {
    btn_gtm = {
        event: 'uaEvent',
        event_name: 'video',
        title_name: gtm_title_name || title,
        position: gtm_position || 'Product Detail_1',
    };
    //}
    return (
        <div className={classes}>
            <EfImgVideo isVideo={isVideo} pc={pc} pad={pad} h5={h5} autoPlay={true} loop={true} poster={poster} posterH5={posterH5} />
            <div className={`${prefixCls}-info`}>
                <div className={`${prefixCls}-in`}>
                    {label && <div className={`${prefixCls}-label`}>{label}</div>}
                    {title && <div className={`${prefixCls}-title`}>{title}</div>}
                    {subTitle && <div className={`${prefixCls}-subTitle`}>{subTitle}</div>}
                    {desc && <div className={`${prefixCls}-desc`}>{desc}</div>}
                    {hasBtn && (
                        <div className={`${prefixCls}-btns`}>
                            {btn_text && btn_link && (
                                <button
                                    className={`${prefixCls}-btn ${prefixCls}-btn-1`}
                                    onClick={() => {
                                        openHandle(btn_link);
                                        btn_gtm && gtm.push(btn_gtm);
                                    }}
                                >
                                    {btn_text}
                                    <IconWatch />
                                </button>
                            )}
                            {btn_text2 && btn_link2 && (
                                <button
                                    className={`${prefixCls}-btn ${prefixCls}-btn-2`}
                                    onClick={() => {
                                        openHandle(btn_link2);
                                        btn_gtm && gtm.push(btn_gtm);
                                    }}
                                >
                                    {btn_text2}
                                    <IconWatch />
                                </button>
                            )}
                        </div>
                    )}
                    {hasEmail && <>{emailChildren}</>}
                </div>
            </div>
            {bottomChildren && bottomChildren}
            {openHref && isOpen && <EfDialogYoutube open={isOpen} src={openHref} callback={hideHandle} />}
        </div>
    );
};

export default EfBanner;
